
// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { toast } from 'react-toastify';
// import {
//   FaMapMarkerAlt,
//   FaPhone,
//   FaEnvelope,
//   FaClock,
//   FaWhatsapp,
//   FaFacebook,
//   FaTwitter,
//   FaLinkedin,
//   FaInstagram,
// } from 'react-icons/fa';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     const leads = JSON.parse(localStorage.getItem('wisdom_leads') || '[]');

//     const newLead = {
//       ...formData,
//       calculatorType: 'Contact Form',
//       timestamp: new Date().toISOString(),
//     };

//     leads.unshift(newLead);
//     localStorage.setItem('wisdom_leads', JSON.stringify(leads));

//     setTimeout(() => {
//       toast.success(
//         'Message sent successfully! Our team will contact you shortly.'
//       );

//       setFormData({
//         name: '',
//         email: '',
//         phone: '',
//         message: '',
//       });

//       setIsSubmitting(false);
//     }, 1000);
//   };

//   const contactInfo = [
//     {
//       icon: FaMapMarkerAlt,
//       title: 'Address',
//       details:
//         'E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010',
//     },
//     {
//       icon: FaPhone,
//       title: 'Call Us',
//       details: '9726344477, 9726766777',
//       action: 'tel:9726344477',
//     },
//     {
//       icon: FaEnvelope,
//       title: 'Email',
//       details: 'wisdom2secure@gmail.com',
//       action: 'mailto:wisdom2secure@gmail.com',
//     },
//     {
//       icon: FaWhatsapp,
//       title: 'WhatsApp',
//       details: '9726344477',
//       action: 'https://wa.me/9726344477',
//     },
//     {
//       icon: FaClock,
//       title: 'Working Hours',
//       details: 'Mon - Sat : 10 AM - 7 PM',
//     },
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>Contact Us - Wisdom Consultancy</title>
//       </Helmet>

//       <section className="relative overflow-hidden bg-[#f7f7f7] py-20">
//         {/* Grid Background */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #dcdcdc 1px, transparent 1px),
//               linear-gradient(to bottom, #dcdcdc 1px, transparent 1px)
//             `,
//             backgroundSize: '40px 40px',
//           }}
//         />

//         <div className="container-custom relative z-10">
//           {/* Heading */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             className="max-w-3xl mx-auto text-center mb-14"
//           >
//             <h1 className="text-4xl md:text-6xl font-extrabold leading-tight text-[#0b1c39]">
//               Get in{' '}
//               <span className="text-[#65c16f]">
//                 Touch
//               </span>{' '}
//               with Wisdom Consultancy
//             </h1>

//             <p className="mt-6 text-lg text-gray-600 leading-9">
//               Effortlessly connect with us using our simple inquiry form.
//               Share your details, and our team will respond promptly to assist
//               you.
//             </p>
//           </motion.div>

//           {/* Main Layout */}
//           <div className="grid lg:grid-cols-2 gap-10 items-start">
//             {/* Left Contact Card */}
//             <motion.div
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="bg-[#dfecef] rounded-[35px] p-8 md:p-10 shadow-lg"
//             >
//               <h2 className="text-3xl md:text-4xl font-bold text-[#0b1c39] leading-tight">
//                 Need <span className="text-[#3d63ff]">assistance?</span>
//               </h2>

//               <p className="text-3xl md:text-4xl font-bold text-[#0b1c39] mt-2 mb-10">
//                 We’re always a click away!
//               </p>

//               {/* Form */}
//               <form onSubmit={handleSubmit} className="space-y-5">
//                 <input
//                   type="text"
//                   required
//                   placeholder="Full Name"
//                   value={formData.name}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       name: e.target.value,
//                     })
//                   }
//                   className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
//                 />

//                 <input
//                   type="email"
//                   required
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       email: e.target.value,
//                     })
//                   }
//                   className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
//                 />

//                 <input
//                   type="tel"
//                   required
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       phone: e.target.value,
//                     })
//                   }
//                   className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
//                 />

//                 <textarea
//                   required
//                   rows="5"
//                   placeholder="Message"
//                   value={formData.message}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       message: e.target.value,
//                     })
//                   }
//                   className="w-full rounded-2xl px-6 py-5 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700 resize-none"
//                 />

//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="w-full h-16 rounded-2xl bg-[#0b1c39] text-white font-semibold text-lg hover:bg-[#132b57] transition-all duration-300"
//                 >
//                   {isSubmitting ? 'Sending...' : 'Send Message'}
//                 </button>
//               </form>
//             </motion.div>

//             {/* Right Contact Details */}
//             <motion.div
//               initial={{ opacity: 0, x: 30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="space-y-6"
//             >
//               {/* Info Cards */}
//               {contactInfo.map((info, idx) => (
//                 <div
//                   key={idx}
//                   className="bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
//                 >
//                   <div className="flex items-start gap-5">
//                     <div className="w-14 h-14 rounded-2xl bg-[#e8f5ea] flex items-center justify-center text-[#65c16f] text-xl flex-shrink-0">
//                       <info.icon />
//                     </div>

//                     <div>
//                       <h3 className="text-xl font-bold text-[#0b1c39] mb-1">
//                         {info.title}
//                       </h3>

//                       {info.action ? (
//                         <a
//                           href={info.action}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="text-gray-600 hover:text-[#65c16f] transition-colors"
//                         >
//                           {info.details}
//                         </a>
//                       ) : (
//                         <p className="text-gray-600 leading-7">
//                           {info.details}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ))}

//               {/* Social Links */}
//               <div className="bg-white rounded-3xl p-6 shadow-md">
//                 <h3 className="text-2xl font-bold text-[#0b1c39] mb-5">
//                   Follow Us
//                 </h3>

//                 <div className="flex flex-wrap gap-4">
//                   {[
//                     {
//                       icon: FaFacebook,
//                       link: 'https://facebook.com',
//                       bg: 'bg-blue-600',
//                     },
//                     {
//                       icon: FaTwitter,
//                       link: 'https://twitter.com',
//                       bg: 'bg-sky-500',
//                     },
//                     {
//                       icon: FaLinkedin,
//                       link: 'https://linkedin.com',
//                       bg: 'bg-blue-700',
//                     },
//                     {
//                       icon: FaInstagram,
//                       link: 'https://instagram.com',
//                       bg: 'bg-pink-500',
//                     },
//                     {
//                       icon: FaWhatsapp,
//                       link: 'https://wa.me/9726344477',
//                       bg: 'bg-green-500',
//                     },
//                   ].map((social, idx) => (
//                     <a
//                       key={idx}
//                       href={social.link}
//                       target="_blank"
//                       rel="noreferrer"
//                       className={`w-14 h-14 rounded-2xl ${social.bg} text-white flex items-center justify-center hover:scale-110 transition-transform duration-300`}
//                     >
//                       <social.icon size={22} />
//                     </a>
//                   ))}
//                 </div>
//               </div>

//               {/* Map */}
//               <div className="overflow-hidden rounded-3xl shadow-md">
//                 <iframe
//                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0!2d73.181!3d22.307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8e8b5b8b8b9%3A0x0!2zMjLCsDE4JzI1LjIiTiA3M8KwMTAnNTguNiJF!5e0!3m2!1sen!2sin!4v1699999999999!5m2!1sen!2sin"
//                   width="100%"
//                   height="300"
//                   style={{ border: 0 }}
//                   allowFullScreen=""
//                   loading="lazy"
//                   title="Wisdom Consultancy Location"
//                 />
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Contact;

import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaGoogle,
} from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const leads = JSON.parse(localStorage.getItem('wisdom_leads') || '[]');

    const newLead = {
      ...formData,
      calculatorType: 'Contact Form',
      timestamp: new Date().toISOString(),
    };

    leads.unshift(newLead);
    localStorage.setItem('wisdom_leads', JSON.stringify(leads));

    setTimeout(() => {
      toast.success(
        'Message sent successfully! Our team will contact you shortly.'
      );

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });

      setIsSubmitting(false);
    }, 1000);
  };

  const contactInfo = [
    {
      icon: FaMapMarkerAlt,
      title: 'Address',
      details:
        'E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010',
    },
    {
      icon: FaPhone,
      title: 'Call Us',
      details: '9726344477, 9726766777',
      action: 'tel:9726344477',
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      details: 'wisdom2secure@gmail.com',
      action: 'mailto:wisdom2secure@gmail.com',
    },
    {
      icon: FaWhatsapp,
      title: 'WhatsApp',
      details: '9726344477',
      action: 'https://wa.me/919726344477',
    },
    {
      icon: FaClock,
      title: 'Working Hours',
      details: 'Mon - Sat : 10 AM - 7 PM',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Contact Us - Wisdom Consultancy</title>
      </Helmet>

      <section className="relative overflow-hidden bg-[#f7f7f7] py-20">
        {/* Grid Background */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #dcdcdc 1px, transparent 1px),
              linear-gradient(to bottom, #dcdcdc 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
          }}
        />

        <div className="container-custom relative z-10">
          {/* Heading */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center mb-14"
          >
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight text-[#0b1c39]">
              Get in{' '}
              <span className="text-[#65c16f]">
                Touch
              </span>{' '}
              with Wisdom Consultancy
            </h1>

            <p className="mt-6 text-lg text-gray-600 leading-9">
              Effortlessly connect with us using our simple inquiry form.
              Share your details, and our team will respond promptly to assist
              you.
            </p>
          </motion.div>

          {/* Main Layout */}
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Left Contact Card */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="bg-[#dfecef] rounded-[35px] p-8 md:p-10 shadow-lg"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-[#0b1c39] leading-tight">
                Need <span className="text-[#3d63ff]">assistance?</span>
              </h2>

              <p className="text-3xl md:text-4xl font-bold text-[#0b1c39] mt-2 mb-10">
                We’re always a click away!
              </p>

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-5">
                <input
                  type="text"
                  required
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                  className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
                />

                <input
                  type="email"
                  required
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      email: e.target.value,
                    })
                  }
                  className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
                />

                <input
                  type="tel"
                  required
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      phone: e.target.value,
                    })
                  }
                  className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
                />

                <textarea
                  required
                  rows="5"
                  placeholder="Message"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      message: e.target.value,
                    })
                  }
                  className="w-full rounded-2xl px-6 py-5 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700 resize-none"
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full h-16 rounded-2xl bg-[#0b1c39] text-white font-semibold text-lg hover:bg-[#132b57] transition-all duration-300"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </motion.div>

            {/* Right Contact Details */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="space-y-6"
            >
              {/* Info Cards */}
              {contactInfo.map((info, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
                >
                  <div className="flex items-start gap-5">
                    <div className="w-14 h-14 rounded-2xl bg-[#e8f5ea] flex items-center justify-center text-[#65c16f] text-xl flex-shrink-0">
                      <info.icon />
                    </div>

                    <div>
                      <h3 className="text-xl font-bold text-[#0b1c39] mb-1">
                        {info.title}
                      </h3>

                      {info.action ? (
                        <a
                          href={info.action}
                          target="_blank"
                          rel="noreferrer"
                          className="text-gray-600 hover:text-[#65c16f] transition-colors"
                        >
                          {info.details}
                        </a>
                      ) : (
                        <p className="text-gray-600 leading-7">
                          {info.details}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              {/* Social Links */}
              <div className="bg-white rounded-3xl p-6 shadow-md">
                <h3 className="text-2xl font-bold text-[#0b1c39] mb-5">
                  Follow Us
                </h3>

                <div className="flex flex-wrap gap-4">
                  {[
                    {
                      icon: FaFacebook,
                      link: 'https://www.facebook.com/profile.php?id=100091949229467',
                      bg: 'bg-blue-600',
                    },
                    {
                      icon: FaInstagram,
                      link: 'https://www.instagram.com/yags007/',
                      bg: 'bg-pink-500',
                    },
                    {
                      icon: FaYoutube,
                      link: 'https://www.youtube.com/@yagneshdole3378',
                      bg: 'bg-red-600',
                    },
                    {
                      icon: FaWhatsapp,
                      link: 'https://wa.me/919726344477',
                      bg: 'bg-green-500',
                    },
                    {
                      icon: FaGoogle,
                      link: 'https://share.google/BbsNaz8Fk9VqP3J1u',
                      bg: 'bg-yellow-500',
                    },
                  ].map((social, idx) => (
                    <a
                      key={idx}
                      href={social.link}
                      target="_blank"
                      rel="noreferrer"
                      className={`w-14 h-14 rounded-2xl ${social.bg} text-white flex items-center justify-center hover:scale-110 transition-transform duration-300`}
                    >
                      <social.icon size={22} />
                    </a>
                  ))}
                </div>
              </div>

              {/* Map */}
              <div className="overflow-hidden rounded-3xl shadow-md">
                <iframe
                  src="https://maps.google.com/maps?q=E-44+Vasant+Vihar+Society+GIDC+Vadsar+Road+Vadodara+390010+Gujarat&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Wisdom Consultancy Location"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;